import React, { ChangeEvent } from 'react';
import { civiliteDef } from 'types/client/client.def';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { Select } from 'components/atoms/Inputs/Select';
import emojis from 'theme/emoji';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { LabelInput } from 'components/atoms/Inputs/LabelInput';
import useStyle from './formInvoiceInformation.style';
import { ErrorsForm } from 'types/forms/form.def';
import { ClientInput } from 'types/client/client.def';

interface ClientFieldsProps {
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeSwitch: (value: boolean, name: string) => void;
  client: ClientInput;
  errors: ErrorsForm;
}

export const FormInvoiceInformation = ({
  handleChange,
  handleChangeSwitch,
  client,
  errors
}: ClientFieldsProps) => {
  const classes = useStyle();

  return (
    <>
      <HeaderText text="Informations de Facturation" emoji={emojis['Crayon']} />
      <div style={{ width: '100%' }}>
        <FeatureContainer>
          <div className={classes.selectdiv}>
            <span>Civilité</span>
            <Select
              onChange={value => handleChangeSwitch(value, 'civilite')}
              variant="form"
              productsOptions={[
                { id: 'default', name: 'Choisir une valeur' },
                ...civiliteDef
              ]}
              value={client.civilite || ''}
            />
          </div>
          <LabelInput
            label="Prénom"
            name="prenom"
            placeHolder="ex : Léo"
            onChange={handleChange}
            value={client.prenom || ''}
            required={true}
            error={errors && errors.prenom}
          />
          <LabelInput
            label="Nom"
            name="nom"
            placeHolder="ex : Durand"
            onChange={handleChange}
            value={client.nom || ''}
            required={true}
            error={errors && errors.nom}
          />
          <LabelInput
            label="Téléphone"
            name="tel"
            placeHolder="ex : 0600000000"
            onChange={handleChange}
            value={client.tel || ''}
            required={true}
            error={errors && errors.tel}
          />
          <LabelInput
            label="Email"
            name="mail"
            placeHolder="ex : prenom.nom@gmail.com"
            onChange={handleChange}
            value={client.mail || ''}
            required={true}
            error={errors && errors.mail}
          />
          <LabelInput
            label="Ville"
            name="villefacturation"
            placeHolder="ex : Paris"
            onChange={handleChange}
            value={client.villefacturation || ''}
            required={true}
            error={errors && errors.villefacturation}
          />
          <LabelInput
            label="Adresse de facturation"
            name="adressefacturation"
            placeHolder="ex : 23 rue de la maison"
            onChange={handleChange}
            value={client.adressefacturation || ''}
            required={true}
            error={errors && errors.adressefacturation}
          />
          <LabelInput
            label="Code Postal"
            name="cpfacturation"
            placeHolder="ex : 75000"
            onChange={handleChange}
            value={client.cpfacturation || ''}
            required={true}
            error={errors && errors.cpfacturation}
          />
        </FeatureContainer>
      </div>
    </>
  );
};
